<template>
  <base-card>
    <tab-bar-chart
      class="pb-3"
      :title="title"
      :chartdata="barChartData"
      :height="height"
      :compose-labels="false"
      :options="options"
      :label-size="labelSize"
    />
  </base-card>
</template>
<script>
import TabBarChart from '@/components/charts/TabBarChart';

export default {
  name: 'SalesSummaryChart',
  components: { TabBarChart },
  props: {
    chartdata: {
      type: Array,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    height: {
      type: Number,
      default: 300,
    },
    title: {
      type: String,
      default: "Your Team's Campaign Performance",
    },
    options: {
      type: Object,
      default: () => {},
    },
    labelSize: {
      type: Number,
      default: 13,
    },
  },
  data() {
    return {
      barColor: '#E9AD7D6a',
    };
  },
  computed: {
    barChartData() {
      const borderWidth = 0;
      const barThickness = 100;

      return {
        labels: this.labels,
        datasets: this.chartdata.map((metric) => ({
          backgroundColor: this.barColor,
          borderColor: '#00000000',
          borderWidth,
          barThickness,
          label: metric.name,
          data: metric.values.map((value) => (100 * value)),
        })),
      };
    },
  },
};
</script>
